/**
 * Analytics.js - A wrapper class for ReactGA tracking module
 */
import _ from 'lodash'
import ReactGA from 'react-ga'
import TagManager from 'react-gtm-module'
import Config from '../configs'

ReactGA.initialize(Config.get('GA_TRACKING_ID'), {
  debug: Config.get('GA_TRACKING_DEBUG_MODE')
})
ReactGA.plugin.require('ec')

if (Config.get('GTM_TRACKING_ID')) {
  TagManager.initialize({
    gtmId: Config.get('GTM_TRACKING_ID')
  })
}

export default class Analytics {
  static pageview(options) {
    const prefix = Config.get('GA_TRACKING_PATH_PREFIX')
    let { page } = options
    if (page) {
      if (page.indexOf(prefix) === -1) {
        page = prefix + page
      }
      ReactGA.set({
        title: document.title,
        ...options
      })
      ReactGA.pageview(page)
    }
  }
  static event(options) {
    ReactGA.event(options)
  }

  static execute(options) {
    let { plugin_name, action, action_type, payload } = options
    const args = _.compact([action_type, payload])
    ReactGA.plugin.execute(plugin_name, action, ...args)
  }
}



// WEBPACK FOOTER //
// ./src/lib/analytics.js